import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className="footer-container animate__animated animate__fadeIn animate__delay-1s">
      <div className="footer-content">
        <div className="footer-content__legal">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/cookies">Cookie Policy</Link>
        </div>
        <span className="footer-content__author">
          Made with
          <span className="material-symbols-outlined notranslate">favorite</span> by
          <a
            href="https://www.linkedin.com/in/kraffcho/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Kraffcho
          </a>
        </span>
      </div>
    </footer>
  );
};

export default Footer;
